export default __webpack_public_path__ + "static/media/ro.33482fcd.svg";